import styled from '@emotion/styled';

// 오버레이 스타일
export const CalcOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    pointer-events: none;
`;

// 모달 컨텐츠 스타일
export const CalcContent = styled.div`
    // padding-top: 60px;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
    max-width: 350px;
    width: 90%;
    position: absolute;
    text-align: center;
    overflow: hidden;
    pointer-events: auto;

    input,
    select,
    textarea,
    button {
        user-select: text;
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
        pointer-events: auto;
    }

    input:focus,
    select:focus,
    textarea:focus {
        cursor: text;
    }

    select:focus {
        cursor: pointer;
    }
`;

// 우측 상단 X 아이콘 버튼 스타일
export const CalcCloseIconButton = styled.button`
    position: absolute;
    top: 0px;
    right: 3px;
    background: none;
    border: none;
    font-size: 30px;
    cursor: pointer;
    color: #888;
    transition: color 0.2s ease-in-out;
    line-height: 1;
    padding: 5px;
    z-index: 10;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    &:hover {
        color: #333;
        background-color: rgba(0, 0, 0, 0.05);
    }
`;

// 탭 헤더 스타일
export const TabHeader = styled.div`
    padding-top: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 50px;
    background-color: white;
    border-bottom: 1px solid #e0e0e0;
    cursor: grab;
    touch-action: none;
    transition: cursor 0.2s ease;

    &:active {
        cursor: grabbing;
    }
`;

// 탭 버튼 그룹 스타일
export const TabButtonsGroup = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    height: 100%;
    border-top: 1px solid #e0e0e0;
`;

// 탭 버튼 스타일
export const TabButton = styled.button`
    flex-grow: 1;
    padding: 15px 15px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-size: 15px;
    font-family: 'SCDream4';
    color: #777;
    transition: all 0.3s ease;
    border-bottom: 3px solid transparent;

    &:hover {
        color: #007bff;
        background-color: #f0f0f0;
    }

    &.active {
        color: #007bff;
        font-weight: bold;
        border-bottom: 3px solid #007bff;
        background-color: #e9f5ff;
    }
`;

export const ResultDisplay = styled.div`
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 12px;
    padding: 10px;
    margin-top: 10px;
    // margin-bottom: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const ResultTitle = styled.h4`
    text-align: center;
    margin: 0 0 6px 0;
    color: #495057;
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 6px;
    border-bottom: 2px solid #e9ecef;
`;

export const ResultContent = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ResultRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
    border-bottom: 1px solid #f1f3f4;

    &:last-child {
        border-bottom: none;
    }
`;

export const ResultLabel = styled.span`
    font-weight: 500;
    color: #6c757d;
    font-size: 13px;
`;

export const ResultValue = styled.span`
    font-weight: 600;
    color: #212529;
    font-size: 13px;
`;

export const ResultHighlight = styled.span`
    font-weight: 700;
    color: #dc3545;
    font-size: 13px;
`;

export const ResultNote = styled.p`
    font-size: 10px !important;
    letter-spacing: -1px;
    color: #6c757d;
    padding-top: 15px;
    line-height: 1.5;
    text-align: center;
    font-style: italic;
`;

// 계산기 컨텐츠 스타일
export const CalculatorContent = styled.div`
    text-align: left;
    min-height: 180px;
    display: flex;
    flex-direction: column;
    // gap: 6px;
    padding: 6px;

    // h3 {
    //     margin: 0 0 12px 0;
    //     color: #2c3e50;
    //     font-size: 14px;
    //     text-align: center;
    //     font-weight: 600;
    //     text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    // }

    p {
        color: #555;
        font-size: 13px;
        text-align: center;
        margin: 0 0 8px 0;
    }

    input[type='text'] {
        width: 100%;
        padding: 10px 12px;
        margin-bottom: 6px;
        border: 2px solid #e0e0e0;
        border-radius: 8px;
        font-size: 15px;
        background: #ffffff;
        transition: all 0.3s ease;
        box-sizing: border-box;
        user-select: text;
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;

        &:focus {
            outline: none;
            border-color: #007bff;
            box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
        }

        &::placeholder {
            color: #adb5bd;
            font-size: 12px;
        }
    }

    select {
        width: 100%;
        padding: 10px 12px;
        margin-bottom: 12px;
        border: 2px solid #e0e0e0;
        border-radius: 8px;
        font-size: 15px;
        background: #ffffff;
        transition: all 0.3s ease;
        cursor: pointer;
        user-select: text;
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;

        &:focus {
            outline: none;
            border-color: #007bff;
            box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
        }
    }

    .input-row {
        display: flex;
        gap: 8px;
        align-items: center;
    }

    .input-group {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    input,
    select,
    textarea,
    button {
        user-select: text;
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
        pointer-events: auto;
    }

    input:focus,
    select:focus,
    textarea:focus {
        pointer-events: auto;
    }
`;

// 모달 내부 제목 스타일
export const ModalTitle = styled.h2`
    color: #333;
    margin-bottom: 15px;
`;

// 모달 내부 문단 스타일
export const ModalParagraph = styled.p`
    color: #666;
    line-height: 1.5;
    margin-bottom: 25px;
`;

// 입력 필드 컨테이너 스타일
export const InputContainer = styled.div`
    margin-bottom: 15px;

    p {
        text-align: start;
        margin-top: 10px;
    }
`;

// 라벨 스타일
export const Label = styled.div`
    margin-bottom: 5px;

    span:first-of-type {
        font-weight: bold;
        color: #333;
    }

    span:last-of-type {
        color: #ff4444;
        margin-left: 2px;
    }
`;

// 입력 필드 래퍼 스타일
export const InputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

// 단위 텍스트 스타일
export const UnitText = styled.span`
    color: #666;
    font-size: 14px;
    margin-bottom: 6px;
    white-space: nowrap;
`;

// Select 엘리먼트 스타일
export const StyledSelect = styled.select`
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    background-color: white;
    transition: all 0.3s ease;
    cursor: pointer;
    user-select: text;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;

    &:hover {
        border-color: #007bff;
    }
`;

// 탭 컨텐츠 애니메이션 스타일
export const TabContent = styled.div`
    opacity: 1;
    transform: scale(1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    padding: 18px;
    background-color: white;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;

    &.transitioning {
        opacity: 0.7;
        transform: scale(0.98);
    }

    &.fade-in {
        animation: fadeIn 0.3s ease-in-out;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

// 탭 전환 오버레이 스타일
export const TabTransitionOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;

    &.active {
        opacity: 1;
        pointer-events: auto;
    }

    .loading-spinner {
        width: 40px;
        height: 40px;
        border: 3px solid #f3f3f3;
        border-top: 3px solid #007bff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

// MonthlyRentCalculator 전용 스타일
export const MonthlyRentCalculatorContent = styled.div`
    text-align: left;
    min-height: 180px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 18px;

    h3 {
        margin: 0 0 12px 0;
        color: #2c3e50;
        font-size: 20px;
        text-align: center;
        font-weight: 600;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }

    p {
        color: #555;
        font-size: 13px;
        text-align: center;
        margin: 0 0 8px 0;
    }

    input,
    select,
    textarea,
    button {
        user-select: text;
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
        pointer-events: auto;
    }

    input:focus,
    select:focus,
    textarea:focus {
        pointer-events: auto;
    }
`;

export const MonthlyRentInputRow = styled.div`
    display: flex;
    gap: 8px;
    align-items: flex-end;
    margin-bottom: 12px;
`;

export const MonthlyRentInputGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const MonthlyRentLabel = styled.div`
    margin-bottom: 5px;

    span:first-of-type {
        font-weight: bold;
        color: #333;
    }

    span:last-of-type {
        color: #ff4444;
        margin-left: 2px;
    }
`;

export const MonthlyRentInputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

export const MonthlyRentInput = styled.input`
    width: 100%;
    padding: 10px 12px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    background: #ffffff;
    transition: all 0.3s ease;
    box-sizing: border-box;
    user-select: text;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    }

    &::placeholder {
        color: #adb5bd;
        font-size: 12px;
    }
`;

export const MonthlyRentSelect = styled.select`
    width: 100%;
    padding: 10px 12px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    background: #ffffff;
    transition: all 0.3s ease;
    cursor: pointer;
    user-select: text;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    }
`;

export const MonthlyRentUnitText = styled.span`
    color: #666;
    font-size: 14px;
    white-space: nowrap;
`;
